// More extraction to avoid circular dependencies

import { tableLightColors } from "globals/store/../helpers/table-helpers.data"
import { TableLights } from "src/app/helpers/table.data"
import { EntityBase } from "globals/store/entity.shared.data"
import { MediaTerms } from "globals/store/events.data"
import { MediaTermState } from "globals/store/performers.data"
import { filterEntityMediaTerms } from "globals/store/share.brief.functions"
import { BriefInfo } from "globals/store/share.data"
import { addACommaToLights } from "./performerSponsors.reselector"


export const getMediaTermsLights = <E extends EntityBase>(allTerms: MediaTerms[], entity: E, briefInfo: BriefInfo): TableLights => {
  const terms = filterEntityMediaTerms(allTerms, entity)
  if (!briefInfo || briefInfo.status === 'Off') return {
    percent: -100,
    greyText: 'Brief Off'
  }
  else if (terms.length === 0) return {
    percent: -50,
    greyText: 'No Terms',
  }

  const termStates = terms.map((t): MediaTermState  => {
    const off = entity.noTermsMap[t.id]
    if (off) return 'Off'
    const state = entity.mediaTermsMap[t.id]
    return state || 'Not Accepted'
  })
  const countState = (states: MediaTermState[], state: MediaTermState): number => states.filter(s => s === state).length


  const acceptedCount = countState(termStates, 'Accepted')
  const offCount = countState(termStates, 'Off')
  const rejectedCount = countState(termStates, 'Not Accepted')

  const percent = acceptedCount / termStates.length
  
  const status = { percent, 
    lights: [
      !acceptedCount ? null : { text: `${acceptedCount} accepted`, color: tableLightColors.green },
      !rejectedCount ? null : { text: `${rejectedCount} not accepted`, color: tableLightColors.yellow },
      !offCount ? null : { text: `${offCount} off`, color: tableLightColors.gray },
    ].filter(l => l)
  }
  addACommaToLights(status.lights, 0)

  return status
}